export default "__VITE_ASSET__BGM4Jn3G__"